import { render, staticRenderFns } from "./Item2ColEl.vue?vue&type=template&id=4813a471&scoped=true&"
import script from "./Item2ColEl.vue?vue&type=script&lang=ts&"
export * from "./Item2ColEl.vue?vue&type=script&lang=ts&"
import style0 from "./Item2ColEl.vue?vue&type=style&index=0&id=4813a471&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4813a471",
  null
  
)

export default component.exports